import React from 'react'
import { IssueEntity } from 'types/IssueEntity'
import { translateSourcetype } from '../../../components/utils/translateSourcetype'
import { FactsTableRow } from '../../components/FactsTable'
import { Link } from 'react-router-dom'

/**
 * Takes an url and returns the file part of the url, stripping the file ending and
 * converting dash to non-breaking space.
 *
 * @param {*} url the url to extract the file name from
 */
const presentableName = (url: string) => {
    const parts = url.split('/')
    const fileName = parts[parts.length - 1]
    return fileName.replace(/_/g, '\u00A0').replace('.pdf', '')
}

export function SourceContentRow({ issue }: { issue: IssueEntity }) {
    const source = issue.sources?.find((s) =>
        ['Memorandum', 'Prospectus', 'InformationDocument'].includes(s.sourceType),
    )
    if (!source || !source.sourceUrl) return null

    const sourceLabel = translateSourcetype(source?.sourceType)

    let sourceUrl = source.sourceUrl

    if (!sourceUrl.startsWith('http') && sourceUrl.length > 0) {
        const pathPrefix = sourceUrl[0].toLowerCase()
        if (!sourceUrl.endsWith('.pdf')) {
            sourceUrl = `${sourceUrl}.pdf`
        }
        const baseUrl = import.meta.env.VITE_S3_DOCS_BUCKET_URL || 'https://app-docs.financelab.se/'
        sourceUrl = `${baseUrl}${pathPrefix}/${sourceUrl}`
    }

    return (
        <FactsTableRow label={sourceLabel}>
            <Link to={sourceUrl} target='_blank'>
                {source?.title || presentableName(sourceUrl)}
            </Link>
        </FactsTableRow>
    )
}
